import BCTToken from "./1.0.0/BCTToken";
import AgroforestryInvestmentToken from "./1.0.0/AgroforestryInvestmentToken";
import AgroforestryProject from "./1.0.0/AgroforestryProject";
import BrazilCarbonCreditUnified from "./1.0.0/BrazilCarbonCreditUnified";
import AgroforestryProjectFactory from "./1.0.0/AgroforestryProjectFactory";
import BrazilCarbonKYCWhitelist from "./1.0.0/BrazilCarbonKYCWhitelist";
import BrazilCarbonUniversalCredit1155 from "./1.0.0/BrazilCarbonUniversalCredit1155";
import CarbonCreditInvestmentToken from "./1.0.0/CarbonCreditInvestmentToken";
import CarbonCreditPrivateOffering from "./1.0.0/CarbonCreditPrivateOffering";
import CarbonCreditPublicSale from "./1.0.0/CarbonCreditPublicSale";
import CarbonCreditFuturesPool from "./1.0.0/CarbonCreditFuturesPool";
import SpeciesFuturesPool from "./1.0.0/SpeciesFuturesPool";
import USDC from "./1.0.0/usdc";

// Single source of truth. Every ABI under ./1.0.0/ is bound to this version
// string. If we ever need to support multiple versions side-by-side, do it via
// an explicit map (e.g. ABI_REGISTRY_BY_VERSION), not via an env override that
// can silently pick a stale folder.
export const CONTRACT_VERSION = "1.0.0";

export const ABI_REGISTRY = {
  AgroforestryInvestmentToken,
  BCTToken,
  AgroforestryProject,
  BrazilCarbonCreditUnified,
  BrazilCarbonKYCWhitelist,
  AgroforestryProjectFactory,
  BrazilCarbonUniversalCredit1155,
  CarbonCreditFuturesPool,
  CarbonCreditInvestmentToken,
  CarbonCreditPrivateOffering,
  CarbonCreditPublicSale,
  SpeciesFuturesPool,
  USDC,
};

export const getAbi = (name) => {
  const abi = ABI_REGISTRY[name];
  if (!abi) {
    throw new Error(`ABI not found for ${name}`);
  }
  return abi.abi || abi;
};
